class storageServiceClass {
    constructor() {}

    async getCurrentUser() {
        let res = localStorage.getItem("user");
        try {
          res = JSON.parse(res);
        } catch (e) {
            console.log("Invalid format:",e)
        }
        return res;
      }

      async setCurrentUser(user) {
        try {
          localStorage.setItem('user', JSON.stringify(user));
        } catch (e) {
            console.log("Invalid format:",e)
        }
      }

      async setBizData(user) {
          localStorage.setItem('biz', JSON.stringify(user));
      }

      async getBizData() {
        let res = localStorage.getItem("biz");
        try {
          res = JSON.parse(res);
        } catch (e) {
            console.log("Invalid format:",e)
        }
        return res;
      }




}
const storageServices = new storageServiceClass()
export { storageServices };
